export class EvaButton{
    name:string;
    type:string;
    size:string;

    constructor(name:string,
    type:string,
    size:string){
        this.name=name;
        this.type=type;
        this.size=size;
    }
}



// WEBPACK FOOTER //
// ./public/upgrade/shared/eva-button/eva-button.ts